import { useContext } from 'react';

import { PortalSource } from '../../../../api/src/services/Constants';
import { PortalContext } from '../../context/PortalContext';
import { StoreKeys } from '../useStore/state';
import { useStore } from '../useStore/useStore';

export const useHsidUuid = (): string | undefined => {
  const planSelector = useStore(StoreKeys?.PLAN_SELECTOR);
  const { hsidUuid } = planSelector || {};
  const { portalData } = useContext(PortalContext);
  // For UMR, use uniqueMemberId from portalData as hsidUuid
  if (
    portalData?.portalName?.toLowerCase() === PortalSource?.UMR?.toLowerCase()
  ) {
    return portalData?.portalEligibilityData?.uniqueMemberId;
  }
  return hsidUuid;
};
